import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    toolTip: {
        '& svg': {
            position: 'relative',
            top: 'calc(50% - -9px)',
            fontSize: '20px',
        },
    },
    toggleTooltip: {
        '& svg': {
            position: 'relative',
            top: 'calc(50% - -2px)',
            fontSize: '20px',
        },
    },
}));

const defaultPlacement = 'right';

export default function NgpFieldHelpTip({
    helpText,
    placement = defaultPlacement,
    isToggleField = false,
    ...restProps
}) {
    const classes = useStyles();

    const theClass = isToggleField ? classes.toggleTooltip : classes.toolTip;

    return (
        <Box className={theClass} {...restProps}>
            <Tooltip title={helpText} placement={placement}>
                <HelpOutlineIcon />
            </Tooltip>
        </Box>
    );
}
